// extracted by mini-css-extract-plugin
module.exports = {"varWhite":"var(--tkww-union-color-white, var(--tkww-union-color-neutral-white, #FFF))","fullScreenModal":"fullScreenModal--ef82c"};